import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  GetService,
  PostFormData,
  PostService,
} from "../../../../Services/ConstantService";
import { API_URL } from "../../../../Services/ApiService"; 
import {
  showErrorAlert,
  showSuccessAlert,
} from "../../../../Helper/SweetAlert";
import MoonLoader from "react-spinners/MoonLoader";
export default function Profile() {
  const [username, setusername] = useState("");
  const [first_name, setfirst_name] = useState("");
  const [last_name, setlast_name] = useState("");
  const [email_id, setEmail] = useState("");
  const [paypal_id, setpaypal_id] = useState("");
  const [gateway_id, setgateway_id] = useState("");
  const [login_id, setlogin_id] = useState("");
  const [t_key, sett_key] = useState("");
  const [loading, setLoading] = useState(true);
  const [submitLoader, setsubmitLoader] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    getUserDetails();
  }, []);

  const getUserDetails = async () => {
    setLoading(true);
    GetService(API_URL.ADMIN_DETAIL).then(
      (res) => {
        if (res.data?.status === true) {
          // setUser(res.data.data)
          setusername(res.data.data.username);
          sett_key(res.data.data.t_key);
          setfirst_name(res.data.data.first_name);
          setlast_name(res.data.data.last_name);
          setEmail(res.data.data.email_id);
          setpaypal_id(res.data.data.paypal_id);
          setgateway_id(res.data.data.gateway_id);
          setlogin_id(res.data.data.login_id);
          // if (res.data.data.image) {
          //   setLocalImgPath(ImageURL + res.data.data.image)
          // }
          setLoading(false);
        }
      },
      (err) => {
        showErrorAlert(err.data?.message);
        setLoading(false);
      }
    );
  };

  const submitForm = async (e) => {
    e.preventDefault();
    if (
      !username ||
      !first_name ||
      !last_name ||
      !email_id ||
      !paypal_id ||
      !gateway_id ||
      !login_id ||
      !t_key
    ) {
      setError(true);
      return;
    }

    setsubmitLoader(true);
    const data = {
      username,
      first_name,
      last_name,
      email_id,
      paypal_id,
      gateway_id,
      login_id,
      t_key,
    };

    PostService(API_URL.UPDATE_PROFILE, data).then(
      (res) => {
        console.log(res);
        if (res?.data?.status === true) {
          showSuccessAlert(res?.data?.message);
          setsubmitLoader(false)
          setError(false)
        } else {
          showErrorAlert(res.data?.message);
          setsubmitLoader(false)
          setError(false)
        }
      },
      (err) => {
        // console.log(err?.response?.data);
        showErrorAlert(err.data?.message);
      }
    );
  };
  return (
    <div>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h3>Profile</h3>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <Link
                  to="/panel/dashboard"
                  className="breadcrumb-item"
                  style={{ textDecoration: "none" }}
                >
                  Dashboard
                </Link>
                <Link className="breadcrumb-item active">Profile</Link>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <div className="card">
        <div className="card-body">
          {!loading && (
            <form
              className="forms-sample"
              onSubmit={(e) => {
                submitForm(e);
              }}
            >
              <div className="row">
                <div className="form-group col-md-5 col-12 offset-md-1">
                  <label htmlFor="UserName">User Name</label>
                  <input
                    type="text"
                    className="form-control p-input"
                    id="UserName"
                    aria-describedby="UserName"
                    placeholder="Enter User Name"
                    value={username}
                    onChange={(e) => setusername(e.target.value)}
                  />
                   {error && !username && (
                        <div className="error mt-1">
                          User Name is required
                        </div>
                      )}
                </div>
                <div className="form-group col-md-5 col-12">
                  <label htmlFor="TransactionKey">
                    Transaction Key:(Authorize.net)
                  </label>
                  <input
                    type="text"
                    className="form-control p-input"
                    id="TransactionKey"
                    aria-describedby="TransactionKey"
                    placeholder="Enter email"
                    value={t_key}
                    onChange={(e) => sett_key(e.target.value)}
                  />
                   {error && !t_key && (
                        <div className="error mt-1">
                          Transaction Key is required
                        </div>
                      )}
                </div>
              </div>
              <div className="row">
                <div className="form-group col-md-5 col-12 offset-md-1">
                  <label htmlFor="FirstName">First Name</label>
                  <input
                    type="text"
                    className="form-control p-input"
                    id="FirstName"
                    aria-describedby="FirstName"
                    placeholder="Enter First Name"
                    value={first_name}
                    onChange={(e) => setfirst_name(e.target.value)}
                  />
                   {error && !first_name && (
                        <div className="error mt-1">
                          First Name is required
                        </div>
                      )}
                </div>
                <div className="form-group col-md-5 col-12">
                  <label htmlFor="LastName">Last Name</label>
                  <input
                    type="text"
                    className="form-control p-input"
                    id="LastName"
                    aria-describedby="LastName"
                    placeholder="Enter Last Name"
                    value={last_name}
                    onChange={(e) => setlast_name(e.target.value)}
                  />
                  {error && !last_name && (
                        <div className="error mt-1">
                          Last Name is required
                        </div>
                      )}
                </div>
              </div>

              <div className="row">
                <div className="form-group col-md-5 col-12 offset-md-1">
                  <label htmlFor="EmailAddress">Email Address</label>
                  <input
                    type="email"
                    className="form-control p-input"
                    id="EmailAddress"
                    aria-describedby="EmailAddress"
                    placeholder="Enter Email"
                    value={email_id}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  {error && !email_id && (
                        <div className="error mt-1">
                          Email is required
                        </div>
                      )}
                </div>
                <div className="form-group col-md-5 col-12">
                  <label htmlFor="PaypalId">Paypal Id</label>
                  <input
                    type="text"
                    className="form-control p-input"
                    id="PaypalId"
                    placeholder="Enter PayPal ID"
                    value={paypal_id}
                    onChange={(e) => setpaypal_id(e.target.value)}
                  />
                    {error && !paypal_id && (
                        <div className="error mt-1">
                          Paypal Id is required
                        </div>
                      )}
                </div>
              </div>
              <div className="row">
                <div className="form-group col-md-5 col-12 offset-md-1">
                  <label htmlFor=" GatewayId">Gateway Id:(Authorize.net)</label>
                  <input
                    type="text"
                    className="form-control p-input"
                    id="GatewayId"
                    aria-describedby="GatewayId"
                    placeholder="Enter Gateway Id"
                    value={gateway_id}
                    onChange={(e) => setgateway_id(e.target.value)}
                  />
                     {error && !gateway_id && (
                        <div className="error mt-1">
                          Gateway Id is required
                        </div>
                      )}
                </div>
                <div className="form-group col-md-5 col-12">
                  <label htmlFor="Loginid">Login id:(Authorize.net)</label>
                  <input
                    type="text"
                    className="form-control p-input"
                    id="Loginid"
                    placeholder="Enter Login ID"
                    value={login_id}
                    onChange={(e) => setlogin_id(e.target.value)}
                  />
                   {error && !login_id && (
                        <div className="error mt-1">
                          Login id is required
                        </div>
                      )}
                </div>
              </div>

              <div className="col-12 offset-md-1"> 
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={submitLoader}
                >
                  {submitLoader ? (
                    <i className="fas fa-spinner fa-spin"></i>
                  ) : (
                    "Update"
                  )}
                </button>
              </div>
            </form>
          )}
          {loading && (
            <div className="LoaderSpinner">
                <MoonLoader
                          color={"#003bff"}
                          loading={loading}
                          speedMultiplier={0.6}
                          size={50}
                        />
              <div>Loading... Please wait.</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
